import { bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup } from 'reactstrap';

import SingleSelect from '../../../generic/SingleSelect';
import { getTooltipLabelWithText } from '../../../generic/Tooltip';
import { opportunityShape } from '../../../prop-types';
import { campaignObjectiveOptions } from '../../constants';
import HELP_TEXTS from '../../help-texts';

const TooltipLabel = getTooltipLabelWithText(HELP_TEXTS);

export default function OpportunityCampaignObjective({
  opportunity,
  onChange,
  readOnly,
}) {
  const { campaignObjective, primaryQuoteId } = opportunity;
  return (
    <FormGroup row>
      <TooltipLabel
        text="Campaign Objective"
        colWidth={4}
        helpKey="campaignObjective"
        section="readOnlyFields"
        resource="op"
        className="required"
      />
      <Col sm={8}>
        <SingleSelect
          options={campaignObjectiveOptions}
          id="op-campaignObjective"
          name="campaignObjective"
          value={campaignObjective}
          onChange={onChange}
          readOnly={readOnly || !!primaryQuoteId}
        />
      </Col>
    </FormGroup>
  );
}

OpportunityCampaignObjective.propTypes = {
  opportunity: opportunityShape.isRequired,
  onChange: func,
  readOnly: bool.isRequired,
};

OpportunityCampaignObjective.defaultProps = {
  onChange: () => {},
};
